import CloseIcon from '@mui/icons-material/Close';
import MuiDialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import React from 'react';
import { CancelButton, CloseButton } from '../CommonButtons';

const Dialog = ({ title, action, open, onClose, children, maxWidth, form, ...props }) => {
  return (
    <MuiDialog open={open} maxWidth={maxWidth || 'sm'} fullWidth={!maxWidth} onClose={onClose} {...props}>
      <DialogTitle>{title}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={theme => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.icons.default,
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>{children}</DialogContent>
      {!form && (
        <DialogActions>
          {action ? (
            <CancelButton variant="outlined" onClick={onClose} />
          ) : (
            <CloseButton variant="outlined" onClick={onClose} />
          )}
          {action}
        </DialogActions>
      )}
    </MuiDialog>
  );
};

export default Dialog;
